module.exports = __webpack_public_path__ + "static/scale-model-of-chinatown-san-francisco-in-san-francisco-california-b66dd14e6a2af5284a39d32572ce290e.png";